import {
  createRootRouteWithContext,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import type { QueryClient } from "@tanstack/react-query";
import { AnalyticsInitializer } from "@/components/AnalyticsInitializer";
import { Headers } from "@/components/Headers";
import { Layout } from "@/components/Layout";
import { StaticMenu } from "@/components/StaticMenu";
import { useBrandConfig } from "@/hooks/useBrandConfig";

const useStatic = true;
const welcomeGiftPaths = [
  "/welcome-gift",
  "/welcome-gift/otp",
  "/welcome-gift/result",
  "/welcome-gift/error",
  "/payment/success",
];

const getBrandCode = (origin?: string) => {
  const lower = origin?.toLowerCase() ?? "";
  if (lower.includes("satumeja")) {
    return "satumeja";
  }
  if (lower.includes("dailyaffair")) {
    return "dailyaffair";
  }
  return "unknown";
};

const getBrandTitle = (brand: string) => {
  switch (brand) {
    case "satumeja":
      return "Satu Meja | Online Menu";
    case "dailyaffair":
      return "Daily Affair | Online Menu";
    default:
      return "Restaurant";
  }
};

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: () => {
    const { location } = useRouterState();
    const isStatic = welcomeGiftPaths.indexOf(location.pathname) === -1;
    const originHost = URL.parse(window.location.origin)?.hostname;
    const brand = getBrandCode(location.search.brand ?? originHost);
    const { data: config } = useBrandConfig(brand);
    window.document.title = getBrandTitle(brand);
    const fav = document.querySelector("link[rel~='icon']");
    if (fav) {
      fav.setAttribute("href", config.faviconUrl);
    }

    return (
      <>
        {useStatic && isStatic ? (
          <StaticMenu brand={brand} />
        ) : (
          <Layout>
            {!useStatic && <Headers />}
            <Outlet />
          </Layout>
        )}
        <AnalyticsInitializer />
        <TanStackRouterDevtools />
      </>
    );
  },
});
